import React from 'react'

export default function Tbl({children}) {
  return (
    <div className='tbl'>{children}</div>
  )
}
